import { Sheet } from "react-modal-sheet";
import { useNavigate } from "react-router";
import ModalSheetListItem from "src/components/elements/ModalSheetListItem/ModalSheetListItem";
import baseStyles from "src/global.module.css";

type SelectCreationEventTypeModalProps = {
    isModalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SelectCreationEventTypeModal: React.FC<
    SelectCreationEventTypeModalProps
> = (props) => {
    const navigate = useNavigate();

    const handelCloseModal = () => {
        props.setModalOpen(false);
    };

    return (
        <Sheet
            isOpen={props.isModalOpen}
            onClose={handelCloseModal}
            detent="content-height"
        >
            <Sheet.Container>
                <Sheet.Content>
                    <Sheet.Scroller>
                        <div className={baseStyles.mb16} />
                        <ModalSheetListItem
                            text="まちなかパフォーマンスのイベントを投稿"
                            onClick={() => {
                                navigate("/event/create/certified");
                            }}
                            divider
                        />
                        <ModalSheetListItem
                            text="通常のイベントを投稿"
                            onClick={() => {
                                navigate("/event/create");
                            }}
                        />
                    </Sheet.Scroller>
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={handelCloseModal} />
        </Sheet>
    );
};

export default SelectCreationEventTypeModal;
